import React, { FC } from 'react';
import { ConfigTimelines, EDIT } from '../constants';
import CustomIcon from 'components/CustomIcons';

import {
  StyledHr,
  StyledText,
  StyledTimelineIconWrapper,
  StyledTimelineWrapper,
} from '../styled';
import { getComponentIcon, getVerticalColor } from '../helpers';

const ConfigTimeline: FC<{ currentIndex: number; actionsMode: any }> = ({
  currentIndex,
  actionsMode,
}) => {
  return (
    <>
      {ConfigTimelines.map((name, index) => {
        return (
          <StyledTimelineWrapper key={index}>
            <StyledTimelineIconWrapper>
              <CustomIcon
                componentName={getComponentIcon(
                  currentIndex,
                  index,
                  actionsMode,
                )}
              />
              <StyledText
                variant="b14"
                strong
                className={currentIndex === index ? 'isActive' : ''}
              >
                {name}
              </StyledText>
            </StyledTimelineIconWrapper>
            <div>
              {index !== ConfigTimelines.length - 1 && (
                <StyledHr
                  className={getVerticalColor(currentIndex, index, actionsMode)}
                />
              )}
            </div>
          </StyledTimelineWrapper>
        );
      })}
    </>
  );
};

export default ConfigTimeline;
